// extracted by mini-css-extract-plugin
export var aboveInput = "_iu-0";
export var actionButton = "_iu-5";
export var actionButtonContainer = "_iu-1";
export var actionIcon = "_iu-6";
export var aiInfoContainer = "_iu-2";
export var attachmentWrapper = "_iu-7";
export var bold = "_iu-3";
export var checkIcon = "_iu-8";
export var clickingRecipientBar = "_iu-11";
export var commentThreadSwitch = "_iu-a";
export var draftImage = "_iu-b";
export var draftImageContainer = "_iu-c";
export var draftImages = "_iu-e";
export var editButton = "_iu-g";
export var editor = "_iu-f";
export var editorContainer = "_iu-y";
export var editorErrorTooltipWrapper = "_iu-9";
export var headerDivider = "_iu-h";
export var icon = "_iu-i";
export var info = "_iu-j";
export var internal = "_iu-n";
export var internalDivider = "_iu-k";
export var internalMessage = "_iu-l";
export var messageInputCard = "_iu-m";
export var messageInputForm = "_iu-o";
export var messageInputFormInternal = "_iu-p";
export var options = "_iu-q";
export var publicMessageCustomer = "_iu-s";
export var publicMessageMerchant = "_iu-r";
export var removeImageButton = "_iu-d";
export var replyButtons = "_iu-t";
export var showSignatureButton = "_iu-u";
export var spinner = "_iu-v";
export var verticalButtonDivider = "_iu-4";
export var visibilitySelector = "_iu-w";
export var warning = "_iu-x";
export var wrappingText = "_iu-z";
export var writingInternalNoteTopBorder = "_iu-10";